import React from 'react';
import Checkbox from '@mui/material/Checkbox';

export default function CheckBox({ isChecked, onChange, isCheckbox }) {
	return (
		<div>
			<Checkbox
				checked={isChecked}
				onChange={onChange}
				isCheckbox={isCheckbox}
			/>
		</div>
	);
}
